import { TabCoordination } from './TabCoordination';
import type { TokenRefreshAttemptResult } from './types';

export { TabCoordination };
export type { TokenRefreshAttemptResult, TabInfo } from './types';

let tabCoordinationInstance: TabCoordination | null = null;

export const getTabCoordination = (): TabCoordination => {
  if (!tabCoordinationInstance) {
    tabCoordinationInstance = new TabCoordination();
  }
  return tabCoordinationInstance;
};

export const destroyTabCoordination = async () => {
  if (tabCoordinationInstance) {
    const instanceToDestroy = tabCoordinationInstance;
    tabCoordinationInstance = null;
    await instanceToDestroy.destroy();
  }
};

export const requestCoordinatedTokenRefresh = async (
  requestedByUserId?: string | null
): Promise<TokenRefreshAttemptResult> => {
  if (!tabCoordinationInstance) {
    return { success: false, error: 'Tab coordination is unavailable', terminalFailure: false };
  }

  return tabCoordinationInstance.requestTokenRefresh(requestedByUserId);
};

export const getCurrentTabAuthUserId = (): string | null =>
  tabCoordinationInstance?.getAuthUserId() ?? null;
